module.exports = __webpack_public_path__ + "img/gongshui1.4cc402e1.png";